import { memo } from 'react';
import cn from 'classnames';
import { IContent, ISection } from 'src/interface';
import { useViewTime } from 'src/hooks';
import ContentSection from 'src/modules/content/components/sections/ContentSection';

interface IProps extends ISection<IContent> {
    contentId: number;
}

export function ContentRelatedSection(props: IProps) {
    const { tracking, contentId } = props;
    const { ref } = useViewTime({
        tracking: tracking,
        contentId: contentId,
        threshold: 0.1,
        onFinish: () => {},
    });

    return (
        <ContentSection
            domRef={ref}
            className="topic-section"
            classTitle={cn(
                'relative',
                'w-full mb-[12px]',
                'h-[2.6rem]',
                'text-[2.2rem] leading-[30px] text-[var(--primary)]',
                '[&>a]:block',
                '[&_span]:relative [&_span]:inline-block [&_span]:bg-white [&_span]:z-[1] [&_span]:pr-[15px]',
                'before:h-[2px] before:w-full before:absolute before:bg-[var(--primary)] before:bottom-[4px]',
            )}
            {...props}
        />
    );
}

export default memo(ContentRelatedSection);
